import { Screen } from "./screen";
import { UserWithProfile } from "./user";

export type MaintenanceProblemType = 
  | "power_supply" 
  | "power_issue" 
  | "signal_issue" 
  | "internet_issue" 
  | "no_power_in_area" 
  | "led_panel_change" 
  | "module_replacement" 
  | "programming_config_issue";

export interface MaintenanceProblem {
  id: string;
  type: MaintenanceProblemType;
  label: string;
  icon?: string;
}

export interface MaintenanceReport {
  id: string;
  screenId: string;
  screen?: Screen;
  problems: MaintenanceProblemType[];
  estimatedTimeHours: number;
  details: string;
  createdAt: string;
  reportedById: string;
  reportedBy?: UserWithProfile;
  completedAt?: string | null;
  isCompleted: boolean;
  isDismissed?: boolean;
}

export const MAINTENANCE_PROBLEMS: MaintenanceProblem[] = [
  { id: "power_supply", type: "power_supply", label: "Power supply", icon: "🔌" },
  { id: "power_issue", type: "power_issue", label: "Problema de corriente", icon: "⚡" },
  { id: "signal_issue", type: "signal_issue", label: "Problema de señal", icon: "📶" },
  { id: "internet_issue", type: "internet_issue", label: "Problema de internet", icon: "🌐" },
  { id: "no_power_in_area", type: "no_power_in_area", label: "No hay energía en el área", icon: "🚫" },
  { id: "led_panel_change", type: "led_panel_change", label: "Cambio de cuadros LED", icon: "🟩" },
  { id: "module_replacement", type: "module_replacement", label: "Reemplazo de módulo", icon: "🔁" },
  { id: "programming_config_issue", type: "programming_config_issue", label: "Problema de programación y configuración", icon: "🧠" },
];

export const ESTIMATED_TIME_OPTIONS = [
  { value: 1, label: "1 hora" },
  { value: 2, label: "2 horas" },
  { value: 4, label: "4 horas" },
  { value: 8, label: "8 horas" },
  { value: 24, label: "24 horas" },
]; 